import script from "./AddSku.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddSku.vue?vue&type=script&lang=ts&setup=true"

import "./AddSku.vue?vue&type=style&index=0&id=2e6d80d2&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e6d80d2"]])

export default __exports__